export function isNotNull<T>(item: T | null | undefined): item is T {
  return item != null;
}

type ErrorOrMessage = string | (() => Error);
export function assertNotNull<T>(item: T | null | undefined, msg: ErrorOrMessage = 'Item is null or undefined'): T {
  if (item == null) {
    const error: Error = typeof msg === 'string' ? new Error(msg) : msg();
    throw error;
  }
  return item;
}
